import angular from 'angular';
import copy from 'app/constants';
import { default as reportsDataService } from 'app/services/data/reports.data.service';
import controller from './generate-reports-dialog.controller';
import template from './generate-reports-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
  ssDialogService,
} = library;

export class dialogService {
  getOptions($event, {
    reports = null,
    serviceId = -1,
    groupId = -1,
    customerId = -1,
    atCustId = -1,
    usesFilter = false,
    usesFocus = false
  }) {
    return {
      controller,
      controllerAs: 'generateReportsDialogVM',
      locals: {
        reports,
        serviceId,
        groupId,
        customerId,
        atCustId,
        usesFilter,
        usesFocus
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.global.appReports.generateReportsDialog', [
  copy,
  reportsDataService,
  loaderService,
  alerts,
  ssDialogService
])
  .service('generateReportsDialog', dialogService)
  .name;

console.log('app.components.global.appReports.generateReportsDialog created');
